import { createSelector } from 'reselect'

export const getIsAuthInitialized = (state) => state.authentication.isAuthInitialized
export const getIsSigningOut = (state) => state.authentication.isSigningOut
export const getUsername = (state) => state.authentication.username
export const getAuthCodeUserAlias = (state) => state.authentication.authCodeUserAlias
export const getReferrerUserAlias = (state) => state.authentication.referrerUserAlias

// Breach Data
export const getBreachData = ({ authentication }) => authentication?.unveilPartialData?.breachData ?? null
export const getBreachDataPasswordsCount = createSelector(
  getBreachData,
  (breachData) => breachData?.passwordsCount ?? 0,
)
export const getBreachDataAttributesCount = createSelector(
  getBreachData,
  (breachData) => breachData?.breachesAttributesCount ?? 0,
)
export const getBreachDataBreachesCount = createSelector(getBreachData, (breachData) => breachData?.breachesCount ?? 0)

// Profile Data
export const getProfileData = ({ authentication }) => authentication?.unveilPartialData?.profileData ?? null
export const getProfileDataAttributesCount = createSelector(
  getProfileData,
  (profileData) => profileData?.attributesCount ?? null,
)

export const getPersonalDataPoints = createSelector(
  [getBreachDataAttributesCount, getProfileDataAttributesCount],
  (breachDataAttributesCount, profileDataAttributesCount) => breachDataAttributesCount + profileDataAttributesCount,
)
export const getProfileDataAttributes = createSelector(getProfileData, (profileData) => profileData?.attributes ?? null)
export const getProfileDataName = createSelector(getProfileDataAttributes, (profileData) => profileData?.name ?? null)
export const getProfileDataDateOfBirth = createSelector(
  getProfileDataAttributes,
  (profileData) => profileData.dateOfBirth ?? null,
)
export const getProfileDataGender = createSelector(
  getProfileDataAttributes,
  (profileData) => profileData.gender ?? null,
)
export const getProfileDataPostalCode = createSelector(
  getProfileDataAttributes,
  (profileData) => profileData.postalCode ?? null,
)
export const getProfileDataProfilesCount = createSelector(
  getProfileData,
  (profileData) => profileData?.profilesCount ?? 0,
)

export const getAssociatedIdsCount = createSelector(
  getProfileData,
  (profileData) => profileData?.associatedIdsCount ?? 0,
)

// Unveil Partial Data
export const getHasPartialUnveilData = createSelector(
  [getProfileDataProfilesCount, getBreachDataBreachesCount],
  (profilesCount, breachesCount) => profilesCount > 0 || breachesCount > 0,
)

export const getIsAuthChecked = (state) => state.authentication.isAuthenticated !== null
export const getIsAuthenticated = (state) => !!state.authentication.isAuthenticated

export default {
  getIsAuthInitialized,
  getIsSigningOut,
  getUsername,
  getAuthCodeUserAlias,
  getReferrerUserAlias,
  getBreachData,
  getBreachDataPasswordsCount,
  getBreachDataBreachesCount,
  getProfileData,
  getProfileDataAttributesCount,
  getPersonalDataPoints,
  getProfileDataAttributes,
  getProfileDataName,
  getProfileDataDateOfBirth,
  getProfileDataPostalCode,
  getProfileDataGender,
  getProfileDataProfilesCount,
  getAssociatedIdsCount,
  getHasPartialUnveilData,
  getIsAuthChecked,
  getIsAuthenticated,
}
